import { render, staticRenderFns } from "./Viewer.vue?vue&type=template&id=47390bfb&scoped=true&"
import script from "./Viewer.vue?vue&type=script&lang=js&"
export * from "./Viewer.vue?vue&type=script&lang=js&"
import style0 from "./Viewer.vue?vue&type=style&index=0&id=47390bfb&lang=scss&scoped=true&"
import style1 from "./Viewer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47390bfb",
  null
  
)

export default component.exports